var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"waveBox"},[_c('div',{staticClass:"waveWrapper waveAnimation"},[_c('div',{staticClass:"waveWrapperInner bgTop"},[_c('div',{staticClass:"wave waveTop"})]),_c('div',{staticClass:"waveWrapperInner bgMiddle"},[_c('div',{staticClass:"wave waveMiddle"})]),_c('div',{staticClass:"waveWrapperInner bgBottom"},[_c('div',{staticClass:"wave waveBottom"})])])])
}]

export { render, staticRenderFns }